import { ColumnType } from '../reportingTypes';

/**
 * Parse "today" keyword to actual date string
 */
export const parseToday = (): string => {
  return new Date().toISOString().split('T')[0]; // "YYYY-MM-DD"
};

/**
 * Format date from ISO string to locale date string
 */
export const formatDate = (isoDate: string): string => {
  try {
    const date = new Date(isoDate);
    return date.toLocaleDateString();
  } catch {
    return isoDate;
  }
};

/**
 * Format number with thousand separators
 */
export const formatNumber = (value: number, decimals: number = 0): string => {
  try {
    return value.toLocaleString(undefined, {
      minimumFractionDigits: decimals,
      maximumFractionDigits: decimals
    });
  } catch {
    return String(value);
  }
};

/**
 * Format boolean as Yes/No
 */
export const formatBoolean = (value: boolean): string => {
  return value ? 'Yes' : 'No';
};

/**
 * Format cell value based on column type
 */
export const formatCellValue = (
  value: unknown,
  columnType: ColumnType
): string => {
  if (value === null || value === undefined) {
    return '';
  }

  switch (columnType) {
    case 'date':
      return formatDate(String(value));
    case 'number':
      return formatNumber(Number(value));
    case 'boolean':
      return formatBoolean(Boolean(value));
    case 'string':
    default:
      return String(value);
  }
};

/**
 * Convert date object to ISO string (YYYY-MM-DD) for API
 */
export const dateToISOString = (date: Date | string): string => {
  if (typeof date === 'string') {
    return date;
  }
  return date.toISOString().split('T')[0];
};
